import { render, staticRenderFns } from "./WarehouseNonCompliantProductView.vue?vue&type=template&id=018c2f0c&scoped=true"
import script from "./WarehouseNonCompliantProductView.vue?vue&type=script&lang=js"
export * from "./WarehouseNonCompliantProductView.vue?vue&type=script&lang=js"
import style0 from "./WarehouseNonCompliantProductView.vue?vue&type=style&index=0&id=018c2f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c2f0c",
  null
  
)

export default component.exports